import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import reducers from './reducers'

const rootReducer = combineReducers(reducers)

const store = createStore(rootReducer, compose(applyMiddleware(thunk)))

export default store
